import * as React from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers';
import { selectLoading } from '../store/reducers/commonSlice';

function withLoading(WrappedComponent: React.FC): React.FC {
  const LoadingHOC = (props: any) => {
    const isLoading = useSelector((state: RootState) => selectLoading(state));
    return (
      <Spin tip="Fetching data..." spinning={isLoading}>
        <WrappedComponent {...props} />
      </Spin>
    );
  };
  return LoadingHOC;
}

export default withLoading;
